import ReactDOM from 'react-dom';
import { useHistory } from "react-router-dom";
import { useEffect } from 'react';

const Modal = ({modal, modalData, onSelectedChange}) => {
    const history = useHistory();
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => document.body.style.overflow = 'unset';
     }, []);

    useEffect(() => {
        const close = (e) => {
          if(e.keyCode === 27){
            onSelectedChange(!modal)
          }
        }
        window.addEventListener('keydown', close)
      return () => window.removeEventListener('keydown', close)
    },[])

    const styles = {
        modal: {
            position: 'fixed',
            width: '100%',
            height: '100%',
            zIndex: 1000,
            backgroundColor: 'rgba(33,37,41,0.8)',
            top: 0,
            display: 'flex'
        },
        modalContent: {
            width: '60vw',
            padding: '3rem',
            backgroundColor: '#fff',
            margin: 'auto',
            borderRadius: '0.5rem'
        }
    }


    return ReactDOM.createPortal(
        <div style={styles.modal} onClick={() => onSelectedChange(!modal)}>
            <div style={styles.modalContent}>
                {modalData}
            </div>
        </div>,
        document.getElementById('modal')
    );
};

export default Modal;
